import { render, staticRenderFns } from "./LibraryColorsSelector.vue?vue&type=template&id=54afd66c&"
import script from "./LibraryColorsSelector.vue?vue&type=script&lang=js&"
export * from "./LibraryColorsSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports